import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import BaseModal from '../../../../shared/library/modals/base/modal.jsx';
import Composer from '../../../../shared/library/composer';
import ComposerProvider from '../../../../shared/library/composer/state/provider';
import {withPortal} from '../../../../shared/library/modals/base/portal.jsx';
import {PrivateModeContext} from '../../../../shared/enhancers/private-mode-enchancer';
import {buildPostForStackupAskQuestion} from '../../utils';

const Advice = ({tools, title, onDismiss}) => {
  const privateMode = useContext(PrivateModeContext);

  return (
    <BaseModal title={title} width={800} onDismiss={onDismiss}>
      <ComposerProvider
        post={buildPostForStackupAskQuestion(tools)}
        debug
        privateMode={privateMode}
      >
        <Composer onCancel={onDismiss} />
      </ComposerProvider>
    </BaseModal>
  );
};

Advice.propTypes = {
  onDismiss: PropTypes.func,
  title: PropTypes.string,
  tools: PropTypes.array
};

export default withPortal(Advice);
